import sourceSchemaUIStore from './sourceSchemaUIStore.js';
import sourceSchemaDataStore from './sourceSchemaDataStore.js';

export default {
  modules: {
    ui: sourceSchemaUIStore,
    data: sourceSchemaDataStore
  }
};
